import request from '../request';

export default {
  /**
   * 获取预算配置
   */
  getConfig() {
    return request.get('/admin/budget/config');
  },

  /**
   * 获取今日预算使用状态
   */
  getStatus() {
    return request.get('/admin/budget/status');
  },

  /**
   * 获取历史使用记录
   */
  getHistory(days?: number) {
    return request.get('/admin/budget/history', { params: { days } });
  },

  /**
   * 重置今日预算
   */
  resetTodayBudget() {
    return request.post('/admin/budget/reset');
  },
};
